import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="buttons--delete-button"
export default class extends Controller {
    static targets = ["submitButton"]

    initialize() {
    }

    confirm(event) {
        // This prevents the default action of invoking the controller's delete action.
        // We need to do this to present the user with the confirmation modal
        event.preventDefault();

        // Populate the modal's placeholder
        const confirmationInputElement = document.getElementById('confirmationInput');
        confirmationInputElement.placeholder = 'Permanently delete'

        // Show the modal
        $('#confirmationModal').modal('show');
    }

    delete(event) {
        const confirmationInputElement = document.getElementById('confirmationInput');
        const confirmationText = confirmationInputElement.value;

        if (confirmationText === 'Permanently delete') {
            // Hide the modal
            $('#confirmationModal').modal('hide');

            // Clear the confirmation input
            confirmationInputElement.value = '';
            this._removeConfirmationInputHighlight();

            // Get the form ID from the data attribute
            const formId = this.element.dataset.formTargetId;
            const formElement = document.getElementById(formId);

            // Dispatch a submit event to trigger the Stimulus controller's delete method
            // This allows the Stimulus controller to handle the actual deletion
            const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
            formElement.dispatchEvent(submitEvent);
        } else {
            this._highlightConfirmationInputRed();
        }
    }

    cancel(event) {
        // Clear the placeholder
        document.getElementById('confirmationInput').value = '';
        this._removeConfirmationInputHighlight();

        // Hide the modal and submit the form
        $('#confirmationModal').modal('hide');
    }

    _highlightConfirmationInputRed() {
        const confirmationInputElement = document.getElementById('confirmationInput');
        confirmationInputElement.style.borderColor = 'red';
        confirmationInputElement.style.boxShadow = '0 0 5px red';
    }

    _removeConfirmationInputHighlight() {
        const confirmationInputElement = document.getElementById('confirmationInput');
        confirmationInputElement.style.borderColor = '';
        confirmationInputElement.style.boxShadow = '';
    }
}